export default __webpack_public_path__ + "static/form3-e63834b479e0ca8926ec6f79ec6f8ed1.jpeg";